import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialFinanceState: Dtos.TrialFinance & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    quickbooksAccountId: null,
    quickbooksAccount: null,
    quickbooksClassId: null,
    quickbooksClass: null,
    ctaClauseReference: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialFinanceReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    trial: IFieldState<Dtos.Trial>,
    bctInvoicingPrefix: IFieldState<string>,
    taxInvoiceName: IFieldState<string>,
    quickbooksAccountId: IFieldState<number>,
    quickbooksAccount: IFieldState<Dtos.QuickbooksAccount>,
    quickbooksClassId: IFieldState<number>,
    quickbooksClass: IFieldState<Dtos.QuickbooksClass>,
    ctaClauseReference: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
